import script from "./AdminSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSettings.vue?vue&type=script&setup=true&lang=js"

import "./AdminSettings.vue?vue&type=style&index=0&id=eda61a76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eda61a76"]])

export default __exports__